module.exports = __webpack_public_path__ + "img/75-f5f8ad.png";